// removed by extract-text-webpack-plugin
module.exports = {"survey-list-table":"StudentSurveyList__survey-list-table___3iTAP"};